import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/reports/leads/proposalsSentReportActions'
import { DatePicker, Button, Form, AutoComplete, Input, Icon, Spin } from 'antd'
import _ from 'lodash'
import { convertToOption } from '../../../util'
import ListItems from '../../../components/reports/leads/proposals-sent/ListItem'
import moment from 'moment'
import queryString from 'qs'
import config from '../../../config'

const { API_BASE } = config
const { RangePicker } = DatePicker

const propTypes = {}
const FormItem = Form.Item

class ProposalsSentReportContainer extends Component {
  constructor(props) {
    super(props)

    const filter = [
      moment('2018-01-01', 'YYYY-MM-DD').startOf('month'),
      moment(new Date(), 'YYYY-MM-DD').endOf('month')
    ]

    this.state = {
      filter
    }

    // get lead list
    this.props.proposalsSentReportGetLeadList({})
    // get organization list
    this.props.proposalsSentReportGetOrganizationList({})
  }

  onChange = (date, dateString) => {
    this.setState({
      filter: dateString
    })
  }

  applyFilter = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      this.props.proposalsSentReportGetFullReport({ filters: values })
    })
  }

  handleLeadSearch = _.debounce(value => {
    this.props.proposalsSentReportGetLeadList({
      filters: {
        name: value
      }
    })
  }, 500)

  handleOrganizationSearch = _.debounce(value => {
    this.props.proposalsSentReportGetOrganizationList({
      filters: {
        name: value
      }
    })
  }, 500)

  printReport = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const params = _.omit(values, 'date_range')

      if (values.date_range[0] && values.date_range[1]) {
        params.startDate = moment(values.date_range[0]).format('YYYY-MM-DD')
        params.endDate = moment(values.date_range[1]).format('YYYY-MM-DD')
      }

      const qs = queryString.stringify(params)
      const url = `${API_BASE}/api/reports/leads/proposals-sent/print?${qs}`
      window.open(url, '_blank')
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    const leadListData = _.get(this.props, 'proposalsSentReportActions.leadList.data')
    const loadingLeadList = _.get(this.props, 'proposalsSentReportActions.loadingLeadList')

    const organizationListData = _.get(
      this.props,
      'proposalsSentReportActions.organizationList.data'
    )
    const loadingOrganizationList = _.get(
      this.props,
      'proposalsSentReportActions.loadingOrganizationList'
    )

    const loadingFullReport = _.get(this.props, 'proposalsSentReportActions.loadingFullReport')
    const fullReport = _.get(this.props, 'proposalsSentReportActions.fullReport.data')
    return (
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <div className="row">
          <div className="col-10">
            <h3>Proposals Sent</h3>
          </div>
          <Button icon="printer" onClick={() => this.printReport()} />
        </div>
        <Form layout="vertical">
          <div className="row">
            <div className="col-4">
              <div className="row">
                <div className="col-10">
                  <FormItem label="Select the date range:">
                    {getFieldDecorator('date_range', {
                      rules: [
                        {
                          required: true,
                          message: 'You must enter a value'
                        }
                      ],
                      initialValue: this.state.filter
                    })(<RangePicker onChange={this.onChange} />)}
                  </FormItem>
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="row">
                <div className="col-10">
                  <Spin spinning={loadingLeadList}>
                    <FormItem label="Lead">
                      {getFieldDecorator('lead_id', {})(
                        <AutoComplete
                          onChange={this.handleLeadSearch}
                          dataSource={convertToOption(leadListData)}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          placeholder="Search for a Lead"
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  </Spin>
                </div>
              </div>
              <div className="row">
                <div className="col-10">
                  <Spin spinning={loadingOrganizationList}>
                    <FormItem label="Company">
                      {getFieldDecorator('organization_id', {})(
                        <AutoComplete
                          onChange={this.handleOrganizationSearch}
                          dataSource={convertToOption(organizationListData)}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          placeholder="Search for a Company"
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  </Spin>
                </div>
              </div>
            </div>
          </div>
          <Button type="primary" onClick={() => this.applyFilter()}>
            Submit
          </Button>
        </Form>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <ListItems fullReport={fullReport} loadingFullReport={loadingFullReport} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ proposalsSentReportActions, authentication }, ownProps) => ({
  proposalsSentReportActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions), dispatch)
})

ProposalsSentReportContainer.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(ProposalsSentReportContainer))
)



// WEBPACK FOOTER //
// ./src/containers/reports/leads/ProposalsSentContainer.js